import { Trans } from "@lingui/macro";

import { getExplorerUrl } from "config/chains";
import { helperToast } from "lib/helperToast";
import { keccakString } from "sdk/utils/hash";

import ExternalLink from "components/ExternalLink/ExternalLink";

const notifications: { [id: string]: boolean } = {};

export function pushSuccessNotification(chainId: number, message: string, e: { transactionHash: string }) {
  const { transactionHash } = e;

  const id = keccakString(message + transactionHash);
  if (notifications[id]) {
    return;
  }

  notifications[id] = true;

  const txUrl = getExplorerUrl(chainId) + "tx/" + transactionHash;
  helperToast.success(
    <div>
      {message}
      <br />
      <br />
      <ExternalLink href={txUrl}>
        <Trans>View status</Trans>
      </ExternalLink>
    </div>
  );
}

export function pushErrorNotification(chainId: number, message: string, e: { transactionHash: string }) {
  const { transactionHash } = e;
  const id = keccakString(message + transactionHash);
  if (notifications[id]) {
    return;
  }

  notifications[id] = true;

  const txUrl = getExplorerUrl(chainId) + "tx/" + transactionHash;
  helperToast.error(
    <div>
      {message}
      <br />
      <br />
      <ExternalLink href={txUrl}>
        <Trans>View status</Trans>
      </ExternalLink>
    </div>
  );
}
